/*****************************************
 *               export class
 * @export DashboardConfigBuilder
 * @export DashboardConfigModel
 * @export SubDashboardConfigBuilder
 * @export SubDashboardConfigModel
 *****************************************/

/**
 * @method create
 * @method setAppName
 * @method setSponsorId
 * @method setAgent
 * @method setIsNotiDashboard
 * @method setLocale
 */
export function DashboardConfigBuilder () {
    this.dashboardConfig = new DashboardConfigModel();

    this.create = () => {
        return this.dashboardConfig;
    };

    this.setAppName = (appName) => {
        this.dashboardConfig.strAppName = appName;
        return this;
    };

    this.setSponsorId = (sponsorId) => {
        this.dashboardConfig.strSponsorId = sponsorId;
        return this;
    };

    this.setAgent = (agent) => {
        this.dashboardConfig.strAgent = agent;
        return this;
    };

    this.setIsNotiDashboard = (isNotiDashboard) => {
        this.dashboardConfig.isNotiDashboard = isNotiDashboard;
        return this;
    };

    this.setLocale = (locale) => {
        this.dashboardConfig.strLocale = locale;
        return this;
    };
}

export function DashboardConfigModel() {
    this.strAppName = null;
    this.strSponsorId = null;
    this.strAgent = null;
    this.isNotiDashboard = null;
    this.strLocale = null;

    this.getParams = () => {
        var params = {};

        if (this.strAppName)
            params.app_name = this.strAppName;

        if (this.strSponsorId)
            params.sponsorId = this.strSponsorId;

        if (this.strAgent)
            params.agent = this.strAgent;

        if (this.isNotiDashboard)
            params.noti_dashboard = this.isNotiDashboard;

        if (this.strLocale)
            params.locale = this.strLocale;

        return params;
    };
}

/**
 * @method create
 * @method setDashboardName
 * @method setAppName
 * @method setSponsorId
 * @method setLocale
 */
export function SubDashboardConfigBuilder() {
    this.subDashboardConfig = new SubDashboardConfigModel();

    this.create = () => {
        return this.subDashboardConfig;
    };

    this.setDashboardName = (dashboardName) => {
        this.subDashboardConfig.strDashboardName = dashboardName;
        return this;
    };

    this.setAppName = (appName) => {
        this.subDashboardConfig.strAppName = appName;
        return this;
    };

    this.setSponsorId = (sponsorId) => {
        this.subDashboardConfig.strSponsorId = sponsorId;
        return this;
    };

    this.setLocale = (locale) => {
        this.subDashboardConfig.strLocale = locale;
        return this;
    };
}

export function SubDashboardConfigModel() {
    this.strDashboardName = null;
    this.strAppName = null;
    this.strSponsorId = null;
    this.strLocale = null;

    this.getParams = () => {
        var params = {};
        if (this.strAppName)
            params.app_name = this.strAppName;

        if (this.strSponsorId)
            params.sponsorId = this.strSponsorId;

        if (this.strLocale)
            params.locale = this.strLocale;

        return params;
    };
}
